import Cookies from 'js-cookie';

import { HttpClient } from 'shared/libs/http';
import { MainAnalyticsRequest, MainAnalyticsResponse } from './main-analytics.types';

export class MainAnalyticsApiService {
   public static async load(payload: MainAnalyticsRequest) {
      const tokenKey = Cookies.get('token');
      const adminID = Cookies.get('adminID');

      return await HttpClient.post<MainAnalyticsResponse>('/admin/dashboard', payload, {
         headers: {
            adminid: adminID,
            Authorization: `Bearer ${tokenKey}`,
         },
      });
   }
}
